import type { LucideIcon } from "lucide-react";

interface FeatureDisabledProps {
  icon: LucideIcon;
  title: string;
  hint?: string;
}

/** Empty state for a page whose feature flag is off. The sidebar
 *  already hides the nav entry; this guard catches direct URL hits
 *  (deep links, bookmarks) so we never crash the page render path. */
export function FeatureDisabled({
  icon: Icon,
  title,
  hint = "Enable it in Settings → Features",
}: FeatureDisabledProps) {
  return (
    <div className="py-20 text-center">
      <Icon className="mx-auto mb-3 h-12 w-12 text-slate-300" />
      <h2 className="text-lg font-semibold text-slate-700">{title}</h2>
      <p className="mt-1 text-sm text-slate-500">{hint}</p>
    </div>
  );
}
